import DAboutDefinition from './DAboutDefinition'

export default DAboutDefinition
